import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {useUpdateIncomeContext} from '../contexts/UpdateIncomeContext';
import DataItem from '../../_common/components/DataItem';
import {floatValueSign} from '../../../../utils';
import styles from './styles.module.scss';

export default function UpdateIncome() {
  const {formik, update} = useUpdateIncomeContext();
  const prefix = 'transfersByAgent-update-income';
  const isDeviated = formik.values.avgIncome !== formik.values.realAvgIncome;

  return (
    <div className={styles.card}>
      <h3>
        <FormattedMessage id={`${prefix}-header`} defaultMessage="Confirm data for national insurance"/>
      </h3>
      <div>
        <DataItem
          fieldId={'avgIncome'}
          label={<FormattedMessage id={`${prefix}-expected`} defaultMessage="Expected monthly income"/>}
          value={formik.values.avgIncome}
          topLabelStyle={styles.label}
          customInputStyle={classNames(styles.input, 'text-left')}
          onChange={floatValueSign}
          dir={'ltr'}
          containerStyle={'w-100'}
        />
        <div className={'d-flex justify-content-between align-items-end w-100'}>
          <DataItem
            fieldId={'realAvgIncome'}
            label={<FormattedMessage id={`${prefix}-average`} defaultMessage="Average monthly income"/>}
            value={formik.values.realAvgIncome}
            topLabelStyle={styles.label}
            customInputStyle={classNames(styles.input, 'text-left')}
            onChange={floatValueSign}
            dir={'ltr'}
            disabled={true}
            containerStyle={'w-500px mr-4'}
          />
          <button
            className={styles.primary}
            onClick={() => update()}
            disabled={!formik.isValid}
          >
            <FormattedMessage id={`${prefix}-update`} defaultMessage="Update"/>
          </button>
        </div>
        {isDeviated &&
          <div className={styles.message}>
            <FormattedMessage
              id={`${prefix}-isDeviated`}
              defaultMessage={'The average monthly income is deviating from the expected monthly income!'}
            />
          </div>
        }
      </div>
    </div>
  );
}
